/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationGroup } from './NotificationGroup';
import {
    NotificationGroupFromJSON,
    NotificationGroupFromJSONTyped,
    NotificationGroupToJSON,
    NotificationGroupToJSONTyped,
} from './NotificationGroup';

/**
 * 
 * @export
 * @interface PaginatedNotificationGroupList
 */
export interface PaginatedNotificationGroupList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationGroupList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationGroupList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationGroupList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<NotificationGroup>}
     * @memberof PaginatedNotificationGroupList
     */
    results: Array<NotificationGroup>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationGroupList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedNotificationGroupList interface.
 */
export function instanceOfPaginatedNotificationGroupList(value: object): value is PaginatedNotificationGroupList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedNotificationGroupListFromJSON(json: any): PaginatedNotificationGroupList {
    return PaginatedNotificationGroupListFromJSONTyped(json, false);
}

export function PaginatedNotificationGroupListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotificationGroupList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(NotificationGroupFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedNotificationGroupListToJSON(json: any): PaginatedNotificationGroupList {
    return PaginatedNotificationGroupListToJSONTyped(json, false);
}

export function PaginatedNotificationGroupListToJSONTyped(value?: PaginatedNotificationGroupList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(NotificationGroupToJSON)),
        'num_pages': value['numPages'],
    };
}

